var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThirdPartyIntegrations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M7.6 22.6H1.8c-.5 0-.8-.4-.8-.8V16c0-.5.4-.8.8-.8h5.8c.5 0 .8.4.8.8v5.8c.1.4-.3.8-.8.8m-5.6-1h5.5v-5.5H2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#129BF9",
  d: "M24.2 22.6h-5.8c-.5 0-.8-.4-.8-.8V16c0-.5.4-.8.8-.8h5.8c.5 0 .8.4.8.8v5.8c0 .4-.4.8-.8.8m-5.7-1H24v-5.5h-5.5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M16 10.9h-5.8c-.5 0-.8-.4-.8-.8V4.3c0-.5.4-.8.8-.8H16c.5 0 .8.4.8.8v5.8c0 .4-.3.8-.8.8m-5.7-1h5.5V4.4h-5.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M21.3 13.6c-.2 0-.4-.2-.5-.4-.1-.4-.6-2.7-2.4-4.5-.2-.2-.2-.5 0-.7s.5-.2.7 0c2 2 2.5 4.4 2.6 5.1.1.2-.1.4-.4.5M13.1 21.9c-1.4 0-2.5-.3-2.9-.4-.3-.1-.4-.4-.3-.6.1-.3.4-.4.6-.3.4.1 2.7.8 5.1 0 .3-.1.5.1.6.3.1.3-.1.5-.3.6-1 .3-1.9.4-2.8.4M5.1 13.6q-.15 0 0 0c-.4-.1-.5-.3-.5-.6.1-.7.7-3.1 2.6-5.1.2-.2.5-.2.7 0s.2.5 0 .7c-1.8 1.8-2.3 4.1-2.4 4.5 0 .3-.2.5-.4.5"
})));
export default SvgThirdPartyIntegrations;